<template>
  <label
    v-if="element.label"
    :style="labelStyle"
    class="form-label text-start text-break fs-6 p-0 fw-bold"
    :class="element.name"
    :id="`label-${element.id}`"
    :for="`input-${element.id}`"
    @click.prevent
  >
    {{ element.label }}
    <span v-if="showRequiredMark" class="required-star">*</span>
    <img
      v-if="isTooltipVisible"
      src="@/assets/img/info-icon.svg"
      class="tooltip-info-icon"
      v-tooltip="getTooltipConfig"
    />
  </label>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    element: {
      type: Object,
      required: true,
    },
    labelStyle: { type: Object, default: () => {} },
    fieldStyle: { type: Object, default: () => {} },
  },
  computed: {
    showRequiredMark() {
      return (
        !!this.element?.settings?.required &&
        !this.element?.settings?.disabled &&
        this.element?.type !== 'wrapper' &&
        this.element?.type !== 'html' &&
        String(this.element?.label || '').trim().length > 0
      );
    },
    isTooltipVisible() {
      return this.element?.settings?.tooltip?.trim()?.length > 0;
    },
    getTooltipConfig() {
      return {
        text: this.element.settings.tooltip,
        html: true,
        position: 'right',
        auto: true,
        offsetY: -38,
        offsetX: -8,
        tooltipClass: 'form-builder-label-tooltip',
        bgColor:
          this.fieldStyle?.primaryBrandColor &&
          this.fieldStyle?.primaryBrandColor !== ''
            ? this.fieldStyle?.primaryBrandColor
            : null,
        color:
          this.fieldStyle?.textColor && this.fieldStyle?.textColor !== ''
            ? this.fieldStyle?.textColor
            : null,
      };
    },
  },
};
</script>

<style scoped>
.form-label {
  font-family: 'OpenSans-Bold';
  color: #000000;
  margin: 0px;
  line-height: 27px;
  letter-spacing: -0.02em;
  position: unset;
  margin-bottom: 18px !important;
  display: block;
}
.form-label .tooltip-info-icon {
  margin-left: 2px;
  margin-top: -3px;
  cursor: pointer;
}
.form-label .required-star {
  color: #ff0000;
  margin-left: 4px;
  display: inline-block;
  line-height: 1;
  transform: scale(0.8);
  transform-origin: left center;
  vertical-align: baseline;
}
</style>

<style>
.form-builder-label-tooltip {
  padding: 7px 12px !important;
  font-family: 'OpenSans-regular' !important;
  font-weight: 400 !important;
  font-size: 10px !important;
  letter-spacing: -0.32px !important;
  text-align: left !important;
  max-width: 181px !important;
  background: #000 !important;
}
.form-builder-label-tooltip p {
  margin: 0 0 6px !important;
}
.form-builder-label-tooltip p:last-child {
  margin-bottom: 0 !important;
}
.form-builder-label-tooltip ul,
.form-builder-label-tooltip ol {
  margin: 4px 0 !important;
  padding-left: 18px !important;
}
.form-builder-label-tooltip strong,
.form-builder-label-tooltip b {
  font-family: 'OpenSans-Bold' !important;
}
</style>
